import { DotwData, DotwAnalyticsProps } from './Dotw.d';

export const dotwTrackingObjFactory = (
  data: DotwData | DotwAnalyticsProps
): DotwAnalyticsProps => {
  return {
    active: data?.active,
    category: 'Deal of the Week',
    delivery_date: data?.delivery,
    discounted_price: data?.discountedPrice,
    display: data?.display,
    id: data?.id,
    label: data?.label,
    product: {
      id: data?.productId,
      name: data?.name,
      price: data?.price,
    },
    sell_price: data?.price,
    value: data?.discountedPrice,
  };
};
